<!-- PDFPreviewModal.vue -->
<template>
  <div class="pdf-container">
    <iframe
      v-for="url in arr"
      :key="url"
      :src="generatePdfUrl(url)"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    pdfUrls: { type: String, default: "" } // 接收多个 PDF URL
  },
  watch: {
    pdfUrls: {
      handler(newVal) {
        if (typeof newVal === "string") {
          this.arr = newVal.split(",");
          this.arr = this.arr.map(item => item.replace("http://", "https://"));
          console.log("this.arr========", this.arr);
        } else {
          this.arr = newVal;
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return { visible: false, arr: [] };
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    // 处理 PDF 参数（缩放、隐藏工具栏）
    generatePdfUrl(url) {
      return `${url}`;
    }
  }
};
</script>

<style scoped>
.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  height: 80%;
}
.pdf-container {
  height: calc(100% - 30px);
  overflow-y: auto;
}
iframe {
  width: 100%;
  height: 100%;
}
</style>
